// Hook para manejar los KPIs de mercancía
// Hook for managing merchandise KPIs

import { useQuery } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { MerchandiseKpisApiAdapter, MerchandiseKpisParams } from '../adapters/MerchandiseKpisApiAdapter';
import { apiClientWH } from '@shared/services/ApiClient';
import { useDashboardFilters } from './useDashboardFilters';

export const useMerchandiseKpis = (params: MerchandiseKpisParams = {}) => {
  const { toast } = useToast();
  const { setRefreshingComplete } = useDashboardFilters();
  const merchandiseKpisAdapter = new MerchandiseKpisApiAdapter(apiClientWH);

  const {
    data: merchandiseKpisResponse,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['merchandiseKpis', params],
    queryFn: () => merchandiseKpisAdapter.getMerchandiseKpis(params),
    staleTime: 1 * 60 * 1000, // 1 minuto
    gcTime: 5 * 60 * 1000, // 5 minutos
    onSuccess: () => {
      setRefreshingComplete();
    },
    onError: (error: any) => {
      setRefreshingComplete();
      toast({
        title: 'Error al cargar métricas de mercancía',
        description: error?.message || 'Error inesperado. Inténtalo de nuevo.',
        variant: 'destructive',
      });
    },
  });

  return {
    merchandiseKpis: merchandiseKpisResponse?.data || {
      merchandise_list: [],
      merchandise_sum: 0,
      merchandise_count: 0,
    },
    isLoading,
    isFetching,
    error: error?.message || null,
    refetch,
  };
};
